export default __webpack_public_path__ + "locales/lv/Files.json?hash=87046690a2d9f6254d88ac361b61648a";